import { render, staticRenderFns } from "./FormAlarmKit.vue?vue&type=template&id=2e679884"
import script from "./FormAlarmKit.vue?vue&type=script&lang=js"
export * from "./FormAlarmKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports